<template>
  <a-spin :spinning="isLoading" tip="Please wait...">
    <div class="mb-3">
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-12">
              <div class="row mb-3">
                <div class="col-md-12">
                  <h3 class="mb-0">Bulk Points Adjustment</h3>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="row">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Membership Program
                      </h6>
                      <a-select
                        placeholder="Select membership program"
                        style="width: 100%"
                        v-model="formData.membership_program_id"
                        :disabled="viewMode"
                        @change="onChangeMembershipProgram"
                      >
                        <a-select-option
                          v-for="membershipProgram in options.membershipPrograms"
                          :key="membershipProgram.id"
                          :value="membershipProgram.id"
                        >
                          {{ membershipProgram.name }}
                        </a-select-option>
                      </a-select>
                      <div
                        v-if="$v.formData.membership_program_id.$dirty"
                        class="text-danger"
                      >
                        <div
                          class="error"
                          v-if="!$v.formData.membership_program_id.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Transaction Type
                      </h6>
                      <a-select
                        id="transaction_type"
                        placeholder="Select transaction type"
                        style="width: 100%"
                        v-model="formData.transaction_type_id"
                        :disabled="viewMode"
                      >
                        <a-select-option
                          v-for="transactionType in options.transactionTypes"
                          :key="transactionType.id"
                          :value="transactionType.id"
                          :data-positive-flag="transactionType.positive_flag"
                          @click="setTransactionFlag"
                        >
                          {{ transactionType.name }}
                          ({{ transactionType.positive_flag ? '+' : '-' }})
                        </a-select-option>
                      </a-select>
                      <div
                        v-if="$v.formData.transaction_type_id.$dirty"
                        class="text-danger"
                      >
                        <div
                          class="error"
                          v-if="!$v.formData.transaction_type_id.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Adjustment Reason
                        Type
                      </h6>
                      <a-select
                        placeholder="Select adjustment reason type"
                        style="width: 100%"
                        v-model="formData.adjustment_reason_type_id"
                        :disabled="viewMode"
                      >
                        <a-select-option
                          v-for="reason in options.adjustmentReasonTypes"
                          :key="reason.id"
                          :value="reason.id"
                        >
                          {{ reason.name }}
                        </a-select-option>
                      </a-select>
                      <div
                        v-if="$v.formData.adjustment_reason_type_id.$dirty"
                        class="text-danger"
                      >
                        <div
                          class="error"
                          v-if="!$v.formData.adjustment_reason_type_id.required"
                        >
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col">
                      <h6 class="heading-small text-muted">
                        <span class="text-danger">*</span> Upload File
                      </h6>
                      <div class="input-group mb-3">
                        <div class="custom-file">
                          <a-input
                            placeholder="Member Name"
                            v-model="formData.csv"
                            type="file"
                            accept=".csv"
                            class="custom-file-input"
                            id="inputGroupFile01"
                            @change="handleFileChange"
                          />
                          <label
                            class="custom-file-label"
                            for="inputGroupFile01"
                            >{{ selectedFileName }}</label
                          >
                        </div>
                      </div>
                      <small class="text-muted" v-if="!viewMode">
                        File must be in csv file format. Download template
                        <a href="#" @click="downloadTemplate">here</a>.
                      </small>
                      <div v-if="$v.formData.csv.$dirty" class="text-danger">
                        <div class="error" v-if="!$v.formData.csv.required">
                          Field is required
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pt-2">
                    <div class="row px-2">
                      <div class="col-sm-12">
                        <base-input>
                          <b-form-checkbox
                            v-model="formData.send_sms_notification"
                            :disabled="viewMode"
                            name="check-button"
                            switch
                          >
                            <label class="form-control-label"
                              >Notification</label
                            >
                          </b-form-checkbox>
                        </base-input>
                        <div v-if="formData.send_sms_notification">
                          <div class="row">
                            <div class="col-sm-4">
                              <label class="form-control-label">
                                Channels <span class="text-danger">*</span>
                              </label>
                            </div>
                            <div class="col-sm-8">
                              <div class="row">
                                <base-input class="p-0 m-0">
                                  <a-checkbox
                                    :disabled="viewMode"
                                    v-model="notification.appNotification"
                                  >
                                    <label class="form-control-label"
                                      >App Notification</label
                                    >
                                  </a-checkbox>
                                </base-input>
                              </div>
                              <div class="row">
                                <base-input class="p-0 m-0">
                                  <a-checkbox
                                    :disabled="viewMode"
                                    v-model="notification.smsNotification"
                                  >
                                    <label class="form-control-label"
                                      >SMS Notification</label
                                    >
                                  </a-checkbox>
                                </base-input>
                              </div>
                            </div>
                            <div class="col-sm-12">
                              <div
                                v-if="
                                  $v.notification.atLeastOneNotification.$dirty
                                "
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="
                                    !$v.notification.atLeastOneNotification
                                      .required
                                  "
                                >
                                  Please select atleast one channel
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-sm-12 mb-2">
                              <base-input>
                                <label class="form-control-label">
                                  Title
                                  <span
                                    class="text-danger"
                                    v-if="notification.appNotification"
                                    >*</span
                                  >
                                </label>
                                <a-input
                                  v-model="notification.title"
                                  :disabled="viewMode"
                                />
                                <small
                                  >*Not applicable for SMS notification</small
                                >
                                <div
                                  v-if="$v.notification.title.$dirty"
                                  class="text-danger"
                                >
                                  <div
                                    class="error"
                                    v-if="!$v.notification.title.required"
                                  >
                                    Field is required
                                  </div>
                                </div>
                              </base-input>
                            </div>
                            <div class="col-sm-12 mb-2">
                              <label class="form-control-label">
                                Message <span class="text-danger">*</span>
                                <b-button
                                  class="btn btn-link"
                                  @click="
                                    () => {
                                      $bvModal.show('code-list-modal');
                                    }
                                  "
                                >
                                  ( <u>codes list</u> )
                                </b-button>
                              </label>
                              <a-textarea
                                v-model="notification.message"
                                :disabled="viewMode"
                                :auto-size="{ minRows: 5, maxRows: 5 }"
                              />
                              <div
                                v-if="$v.notification.message.$dirty"
                                class="text-danger"
                              >
                                <div
                                  class="error"
                                  v-if="!$v.notification.message.required"
                                >
                                  Field is required
                                </div>
                              </div>
                            </div>

                            <div class="col-sm-12 mb-2">
                              <label class="form-control-label">
                                Header Image
                                <br />
                                <small
                                  >*Not applicable for SMS notification</small
                                >
                              </label>
                              <div class="input-group mb-3">
                                <div class="custom-file">
                                  <b-form-file
                                    v-if="!viewMode"
                                    data-var-name="points_earning_image_url"
                                    @change="handleFileImageChange"
                                    accept=".jpg, .jpeg, .png"
                                    :placeholder="selectedFileImageName"
                                  ></b-form-file>
                                </div>
                              </div>
                              <div class="row" v-if="notification.image_url">
                                <div class="col">
                                  <base-input label="Image Preview: ">
                                    <br />
                                    <a-button
                                      type="danger"
                                      data-var-name="game_image_url"
                                      @click="removeImage"
                                      block
                                      :disabled="viewMode"
                                    >
                                      <i class="fa fa-trash"> </i> Remove Image
                                    </a-button>
                                    <br />
                                    <img
                                      class="img-fluid img-center img-thumbnail"
                                      :src="notification.image_url"
                                    />
                                  </base-input>
                                </div>
                              </div>
                            </div>
                            <div class="col-sm-12 mb-2">
                              <base-input label="Sending Time">
                                <a-time-picker
                                  use12-hours
                                  format="h:mm a"
                                  @change="smsTimeOnChange"
                                  :value="
                                    notification.sending_time !== null
                                      ? moment(
                                          notification.sending_time,
                                          'hh:mm A'
                                        )
                                      : null
                                  "
                                  :disabled="viewMode"
                                  style="width: 100%"
                                />
                                <small
                                  >*leave blank if notification is real
                                  time</small
                                >
                              </base-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end">
                    <div class="p-1">
                      <b-button
                        size="sm"
                        class="float-md-left"
                        style="margin-left: 8px"
                        @click.prevent="closeDrawer"
                      >
                        Cancel
                      </b-button>
                    </div>
                    <div class="p-1">
                      <b-button
                        size="sm"
                        @click="confirmAdjustment"
                        variant="success"
                      >
                        <b-spinner v-if="submitLoading" small></b-spinner>
                        Import
                      </b-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal id="code-list-modal" hide-footer hide-header>
        <div class="d-block text-center">
          <div class="row">
            <div class="col">
              <h2>Available Codes</h2>
              <hr class="mt-1 mb-1" />
              {customer_name}<br />
              <span>{points_adjustment}<br /></span>
              {updated_points}<br />
              {transaction_date}<br />
            </div>
          </div>
        </div>
        <hr class="mt-1 mb-1" />
        <div class="col">
          <div class="d-flex justify-content-end">
            <b-button
              class="mt-3 float-end w-25 btn-sm"
              variant="primary"
              @click="$bvModal.hide('code-list-modal')"
              >OK</b-button
            >
          </div>
        </div>
      </b-modal>
    </div>
  </a-spin>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required, requiredIf } from 'vuelidate/lib/validators';
import moment from 'moment';
import secureStorage from '../../controllers/secureStorage';
import { Modal } from 'ant-design-vue';
import axios from 'axios';
const S3Api = process.env.VUE_APP_BXI_S3_API;

export default {
  name: 'PointsAdjustmentForm',
  props: {
    pointsAdjustmentData: Object,
    viewMode: Boolean,
    type: String,
    drawerVisible: Boolean
  },
  components: {},
  data() {
    return {
      isLoading: false,
      selectedFileName: 'Choose file',
      selectedFileImageName: 'Choose file',
      searchLoading: false,
      submitLoading: false,
      query: null,
      querySuccess: false,
      transactionFlag: false,
      searchPlaceHolder: 'Card number',
      example: 'Card Number (e.g. 100000234567)',
      threshold: 3,
      memberData: {
        firstname: '',
        lastname: '',
        membershipProgramId: '',
        membershipLevelId: '',
        currentPointsBalanceExpiring: 0,
        currentPointsBalanceActive: 0
      },
      formData: {
        send_sms_notification: false,
        membership_program_id: null,
        transaction_type_id: null,
        adjustment_reason_type_id: null,
        csv: null,
        data: null
      },
      notification: {
        title: null,
        message: null,
        smsNotification: false,
        appNotification: false,
        image: null,
        image_url: null,
        sending_time: null,
        is_same_or_before: false
      },
      options: {
        transactionTypes: [],
        adjustmentReasonTypes: [],
        membershipPrograms: [],
        membershipLevels: []
      }
    };
  },

  validations: {
    formData: {
      membership_program_id: { required },
      transaction_type_id: { required },
      adjustment_reason_type_id: { required },
      csv: { required }
    },

    notification: {
      title: {
        required: requiredIf(function () {
          return (
            this.formData.send_sms_notification &&
            this.notification.appNotification
          );
        })
      },
      message: {
        required: requiredIf(function () {
          return this.formData.send_sms_notification;
        })
      },
      atLeastOneNotification: {
        required: requiredIf(function () {
          return (
            this.formData.send_sms_notification &&
            !this.notification.appNotification &&
            !this.notification.smsNotification
          );
        })
      }
    }
  },

  methods: {
    removeImage() {
      this.selectedFileImageName = 'Choose a image ...';
      this.notification.image = null;
      this.notification.image_url = null;
    },
    async handleFileImageChange(event) {
      this.notification.image = [event.target.files[0]];
      const { src } = await this.readFileContent(event.target.files[0]);
      this.notification.image_url = src;
    },
    readFileContent(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (evt) => {
          let img = new Image();
          img.src = evt.target.result;
          img.onload = function () {
            resolve({
              src: img.src,
              width: img.width,
              height: img.height
            });
          };
        };
        reader.onerror = reject;
      });
    },
    openModal() {
      this.codeList.visible = true;
    },
    closeModal() {
      this.codeList.visible = false;
    },

    isTimeInPast(targetTime) {
      const currentTime = moment();
      const targetMoment = moment(targetTime, 'h:mm a');
      this.notification.is_same_or_before =
        targetMoment.isSameOrBefore(currentTime);
    },

    smsTimeOnChange(time, timeString) {
      this.notification.sending_time = timeString;
      this.isTimeInPast(timeString);
    },
    closeDrawer() {
      this.resetData();
      this.$emit('closeDrawer', null);
    },
    onChangeMembershipProgram() {
      this.formData.adjustment_reason_type_id = null;
      this.getAdjustmentReasonTypes(this.formData.membership_program_id);
    },
    confirmAdjustment() {
      Modal.confirm({
        title: 'Confirm',
        content:
          'Are you sure you want to proceed with the bulk points adjustment? This action cannot be reverted and processing may take a while.',
        okText: 'Yes',
        cancelText: 'No',
        onOk: () => {
          this.onSubmit(); // Proceed with the points adjustment
        },
        onCancel: () => {
          // Do nothing, user canceled
        }
      });
    },
    validateCsvHeaders(headers) {
      const requiredHeaders = [
        'member_id',
        'points',
        'store_code',
        'sbu',
        'reference_terminal_id',
        'reference_transaction_id',
        'reference_transaction_date',
        'remarks'
      ];
      for (const header of requiredHeaders) {
        if (!headers.includes(header)) {
          return false;
        }
      }
      return true;
    },
    handleFileChange(event) {
      const fileInput = event.target;
      if (fileInput.files.length > 0) {
        const selectedFile = fileInput.files[0];
        this.selectedFileName = selectedFile.name;

        const reader = new FileReader();
        reader.onload = (e) => {
          this.isLoading = true;
          try {
            const contents = e.target.result;
            // const lines = contents.split('\n');
            const lines = contents
              .split('\n')
              .map((line) => line.trim())
              .filter((line) => line.length > 0);

            if (lines.length > 0) {
              const headers = lines[0]
                .split(',')
                .map((header) => header.trim());
              if (!this.validateCsvHeaders(headers)) {
                this.selectedFileName = 'Choose file';
                this.formData.csv = null;

                throw new Error(
                  'Missing header on uploaded file. CSV headers must include member_id, points, store_code, sbu, reference_terminal_id, reference_transaction_id, reference_transaction_date, and remarks.'
                );
              }

              // exclude headers
              const dataLines = parseInt(lines.length) - 1;

              if (dataLines > this.threshold) {
                throw new Error(
                  `CSV upload limit exceeded. Only ${this.threshold} rows are allowed.`
                );
              }

              for (let i = 1; i < lines.length; i++) {
                const row = i + 1;
                const col = lines[i].split(',').map((field) => field.trim());

                const points = col[1];
                const expiration = col[6];

                if (isNaN(points)) {
                  throw new Error(
                    `Invalid points value in row ${row}: ${points}. Value should be a valid number`
                  );
                } else {
                  if (points === '0' || points === 0) {
                    `Invalid points value in row ${row}: ${points}. Value should be greater than 0`;
                  }
                }

                if (expiration) {
                  const today = moment();
                  const expirationDate = moment(expiration);

                  if (!moment(expiration, 'MM/DD/YYYY', true).isValid()) {
                    throw new Error(
                      `Invalid expiration date in row ${row}: ${expiration}. Please enter a valid date format (MM/DD/YYYY).`
                    );
                  }

                  if (expirationDate.diff(today, 'days') < 0) {
                    throw new Error(
                      `Invalid expiration date in row ${row}: ${expiration}. Previous dates are not allowed.`
                    );
                  }
                }
              }
            }
          } catch (err) {
            this.selectedFileName = 'Choose file';
            this.formData.csv = null;
            this.$notification.error({
              message: err?.message ?? err
            });
          } finally {
            this.isLoading = false;
          }
        };

        this.formData.data = selectedFile;
        reader.readAsText(selectedFile);
      } else {
        this.selectedFileName = 'Choose file';
      }
    },
    downloadTemplate() {
      const csvContent =
        'member_id,points,store_code,sbu,reference_terminal_id,reference_transaction_id,reference_transaction_date,remarks';
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', 'Bulk Points Adjustment Template.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },
    moment,
    setTransactionFlag(el) {
      const positiveFlag = el.item.$el.dataset.positiveFlag == 1 ? true : false;
      this.transactionFlag = positiveFlag;
    },

    async s3Upload(file = []) {
      if (file && file.length > 0 && file[0] instanceof File) {
        console.log('Uploading to S3');
        const formData = new FormData();
        formData.append('file', file[0]);
        let filePath = null;
        try {
          const upload = await axios({
            method: 'POST',
            url:
              S3Api +
              '?account_name=' +
              this.accountName +
              '&profile=app-notification-image',
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem('uploadToken')
            },
            data: formData
          });

          if (typeof upload.data.path !== 'undefined' && upload.data.path) {
            console.log('File uploaded');
            filePath = upload.data.path;
          } else {
            console.log('No upload path');
            this.$message.error('Unable to upload image. Please try again!');
          }

          return filePath;
        } catch (err) {
          this.$message.error('Unable to upload image. Something went wrong!');
          throw err;
        }
      }

      return null;
    },

    async onSubmit() {
      this.$v.formData.$touch();
      this.$v.notification.$touch();

      if (!this.$v.formData.$invalid && !this.$v.notification.$invalid) {
        if (this.formData.send_sms_notification && this.notification.image) {
          let url = await this.s3Upload(this.notification.image);
          if (url) {
            this.notification.image_url = url;
          }
        }

        this.submitLoading = true;
        const formData = new FormData();
        formData.append(
          'membership_program_id',
          this.formData.membership_program_id
        );
        formData.append(
          'transaction_type_id',
          this.formData.transaction_type_id
        );
        formData.append(
          'adjustment_reason_type_id',
          this.formData.adjustment_reason_type_id
        );
        formData.append('csv', this.formData.data);
        const notificationFormData = new FormData();
        notificationFormData.append('title', this.notification.title);
        notificationFormData.append('message', this.notification.message);
        notificationFormData.append(
          'smsNotification',
          this.notification.smsNotification
        );
        notificationFormData.append(
          'appNotification',
          this.notification.appNotification
        );
        notificationFormData.append('image', this.notification.image);
        notificationFormData.append('image_url', this.notification.image_url);
        notificationFormData.append(
          'sending_time',
          this.notification.sending_time
        );
        notificationFormData.append(
          'is_same_or_before',
          this.notification.is_same_or_before
        );
        notificationFormData.append(
          'send_sms_notification',
          this.formData.send_sms_notification
        );

        for (const pair of notificationFormData.entries()) {
          formData.append(pair[0], pair[1]);
        }
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_transactions/points_adjustment/bulk?origin_site_id=' +
            secureStorage.getItem('currentSiteId'),
          formData,
          secureStorage.getItem('bxiClpAccessToken'),
          'multipart/form-data'
        );

        if (response.message != undefined && response.message == 'Success') {
          this.$emit('closeDrawer', null);
          this.$root.$emit('refreshTable');
          this.$notification.success({
            message: 'Import completed.'
          });

          this.resetData();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }

        this.submitLoading = false;
      }
    },

    async getTransactionTypes() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_transaction_types?manual_flag=1',
        { per_page: 1000 }
      );

      this.options.transactionTypes = response.data;
    },
    async getMembershipPrograms() {
      const response = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs',
        { per_page: 1000 }
      );
      this.options.membershipPrograms = response.data.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
      this.formData.membership_program_id = response.data[0].id;
      await this.getAdjustmentReasonTypes(response.data[0].id);
    },
    async getAdjustmentReasonTypes(membershipProgramId) {
      const data = await HTTPRequest.getRequest(
        `/api/v1/clp_membership_programs/${membershipProgramId}/adjustment_reason_types`
      );

      this.options.adjustmentReasonTypes = data;
    },
    resetData() {
      this.formData = {
        membership_program_id: null,
        transaction_type_id: null,
        adjustment_reason_type_id: null,
        csv: null,
        send_sms_notification: false,
        data: null
      };
      this.notification = {
        title: null,
        message: null,
        smsNotification: false,
        appNotification: false,
        image: null,
        image_url: null,
        sending_time: null,
        is_same_or_before: false
      };
      this.selectedFileName = 'Choose file';
      this.selectedFileImageName = 'Choose file';
      this.query = null;
      this.querySuccess = false;
      this.$v.formData.$reset();
      this.$v.notification.$reset();
    }
  },

  created() {
    this.getTransactionTypes();
    this.getMembershipPrograms();
  },

  computed: {
    accountName() {
      return this.$store.getters.getAccount?.account_name ?? null;
    }
  },
  watch: {
    pointsAdjustmentData: function (data) {
      this.setFormData(data);
    }
  }
};
</script>

<style scoped></style>
